const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"23ddd28fea0f7b707ea56f82fda93af263369f8d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["xmas-2021@cherry-vc"]={id:"23ddd28fea0f7b707ea56f82fda93af263369f8d"};
      